module.exports = __webpack_public_path__ + "static/shape-left-183fef31f17518ec4ef4913a7d909010.png";